import AuthLayout from "@container/layout/auth";
import AgentDashboard from "@container/agent-dashboard";

export default function AgentDashboardPage() {
    return (
        <AuthLayout>
            <AgentDashboard />
        </AuthLayout>
    );
}
